import { render } from "./TimetableAddForm.vue?vue&type=template&id=53949387&scoped=true"
import script from "./TimetableAddForm.vue?vue&type=script&lang=js"
export * from "./TimetableAddForm.vue?vue&type=script&lang=js"

import "./TimetableAddForm.vue?vue&type=style&index=0&id=53949387&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53949387"]])

export default __exports__